import { memo } from 'react';
import styled from 'styled-components';

import Label from 'components/core/typography/Label';

import { SPACE_300 } from 'styles/tokens';

import { MultiNavLinkSubItemCSS, MultiNavLinkSubItemsContainerCSS } from './shared/CommonNavItems';
import { WrapLink } from './shared/WrapLink';

export const MultiNavLinkSubItemsContainer = styled.div`
  ${MultiNavLinkSubItemsContainerCSS}
`;

const MultiNavLinkSubItemsContainerInner = styled.div`
  border-radius: 5px;
  box-shadow: 0 0 ${SPACE_300} 0 rgba(0, 0, 0, 0.13);
`;

const MultiNavLinkSubItem = styled(WrapLink)`
  ${MultiNavLinkSubItemCSS}
`;

interface MultiNavLinkSubItem {
  label: string;
  title?: string;
  url: string;
}

interface Props {
  items: MultiNavLinkSubItem[];
}

const MultiNavLinkSubItems = ({ items }: Props) => (
  <MultiNavLinkSubItemsContainer>
    <MultiNavLinkSubItemsContainerInner>
      {items.map(item => (
        <MultiNavLinkSubItem key={item.url} title={item.title || item.label} to={item.url}>
          <Label>{item.label}</Label>
        </MultiNavLinkSubItem>
      ))}
    </MultiNavLinkSubItemsContainerInner>
  </MultiNavLinkSubItemsContainer>
);

export default memo(MultiNavLinkSubItems);
